export default {"src":"/_next/static/media/dropdown-menu-arrow-black.78cd798f.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};